import { render, staticRenderFns } from "./AlphaSaasAgreement.vue?vue&type=template&id=08109bd6&scoped=true"
import script from "./AlphaSaasAgreement.vue?vue&type=script&lang=js"
export * from "./AlphaSaasAgreement.vue?vue&type=script&lang=js"
import style0 from "./AlphaSaasAgreement.vue?vue&type=style&index=0&id=08109bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08109bd6",
  null
  
)

export default component.exports